<template>
  <div>
    <el-form
      :model="queryParams"
      :rules="rules"
      ref="basicInfo"
      style="margin-bottom: 0; background-color: #fff; padding: 20px"
      label-width="140px"
    >
      <el-form-item label="园区机构编号：" prop="parkId">
        <el-input v-model="queryParams.parkId" placeholder="请输入" />
      </el-form-item>

      <el-form-item label="园区机构名称：" prop="name">
        <el-input v-model="queryParams.name" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="园区机构类型：" prop="souceDataType">
        <el-checkbox-group v-model="queryParams.checkedSources">
          <el-checkbox
            v-for="source in dataSources"
            :key="source.value"
            :label="source.value"
          >
            {{ source.label }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="园区机构类型：" prop="parkName">
        <el-checkbox-group v-model="queryParams.parkName">
          <el-checkbox
            v-for="source in dataSources1"
            :key="source.value"
            :label="source.value"
          >
            {{ source.label }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="具体地址" prop="location">
        <el-input
          v-model="queryParams.location"
          type="textarea"
          placeholder="具体地址"
          resize="none"
          rows="2"
          maxlength="50"
        />
      </el-form-item>
      <el-form-item label="园区面积：" prop="companyCount">
        <el-input v-model="queryParams.companyCount" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="*园区地理坐标：" prop="region">
        <el-input v-model="queryParams.region" placeholder="请输入" />
      </el-form-item>
      <el-form-item label="园区介绍：" prop="valueDescription">
        <el-input
          v-model="queryParams.valueDescription"
          type="textarea"
          placeholder="园区介绍"
          resize="none"
          rows="5"
          maxlength="500"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// utils
import { debounce } from "@/utils/index.js";

export default {
  name: "EnterpriseInfo",
  components: {},
  data() {
    return {
      queryParams: {
        // 超级个体姓名（带星号表示必填字段）
        name: "",
        // 价值描述（个体价值定位）
        valueDescription: "",
        checkedSources: [],
        parkName: [],
        region: "",
        companyCount: "",
        location: "",
      },
      isInit: false,
      dataSources: [
        { label: "工业园区", value: "0" },
        {
          label: "数字园区",
          value: "1",
        },
        {
          label: "科技园区",
          value: "2",
        },
        { label: "文创园区", value: "3" },
        { label: "其他园区", value: "4" },
      ],
      dataSources1: [
        { label: "民营园区", value: "0" },
        {
          label: "政府园区",
          value: "1",
        },
        {
          label: "高校园区",
          value: "2",
        },
        { label: "其他园区", value: "3" },
      ],
      rules: {
        parkId: [
          { required: true, message: "请输入园区机构编号", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入园区机构名称", trigger: "blur" },
        ],
        companyCount: [
          { required: true, message: "请输入园区面积", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请输入园区面积", trigger: "blur" },
        ],
      },
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.company {
  background: #fff;
  padding: 20px 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .company_left {
    display: flex;
    .info {
      margin-left: 20px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      .fullName {
        display: flex;
        align-items: center;
        .jr-iconjr-icon-edit1:hover {
          color: #4d77ff;
        }
        .el-button {
          margin-left: 10px;
        }
        .companyFullName {
          font-size: 24px;
          color: #363e4d;
        }
        i {
          margin-left: 10px;
        }
      }

      .updateTime {
        color: #7c7f8e;
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }
  .company_right {
    font-size: 12px;
    color: #7c7f8e;
  }
}
/deep/ .el-tabs__content {
  overflow: auto;
}
.companyInfo {
  background: #fff;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  .el-form-item {
    margin-bottom: 0;
  }
  .avatar {
    margin-right: 20px;
  }
}

.bottom {
  border-top: 1px solid #dbdbdb;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  justify-content: center;
  .el-button {
    margin: 0 20px;
  }
}
.leave {
  width: 426px !important;
  height: 84px !important;
  padding: 10px 0;
  background: #f5f6f7;
}
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  width: 470px;
}
</style>
